export default class Observer {
    constructor (store) {
      this._store = store
      this._observers = []
      store.subscribe(() => {
        this._observers.forEach((observer) => {
          const state = store.getState()
          const nextValue = observer.selector(state)
          const prevValue = observer.previousValue
  
          if (nextValue !== prevValue) {
            observer.previousValue = nextValue
            setTimeout(() => {
              // use timeout to prevent nested dispatches on the store
              observer.action(prevValue, nextValue, state)
            }, 0)
          }
        })
      })
    }
  
    observe (selector, action) {
      const state = this._store.getState()
      const previousValue = selector(state)
      this._observers.push({ selector, action, previousValue })
    }
}
  